import React from 'react';
import PropTypes from 'prop-types';
import { Chart } from '@bvt-atoms';
import Highcharts from 'highcharts/highstock';
import HighchartsMore from 'highcharts/highcharts-more';
HighchartsMore(Highcharts);

/**
 *
 * @param {object} props
 * @param {Array<{
 * name: string
 * total: number
 * }>} props.data
 */

export default function ProfessionChart(props) {
  const categories = props.data.map(({ name }) => name);
  const values = props.data.map(({ total }) => total);
  const sum = values.reduce((a, b) => a + b, 0);
  const series = props.data.map(({ name }) => ({
    name,
    data: values.map((num) => (num / sum) * 100),
    pointPlacement: 'on',
    opacity: 0.1,
  }));

  /** @type {import('highcharts/highstock').Options} */
  const option = {
    accessibility: {
      enabled: false,
    },
    chart: {
      polar: true,
      type: 'area',
      backgroundColor: 'transparent',
    },
    credits: {
      enabled: false,
    },
    title: {
      text: null,
    },
    pane: {
      size: '90%',
    },
    xAxis: {
      categories: categories,
      tickmarkPlacement: 'off',
      lineWidth: 0,
    },
    yAxis: {
      gridLineInterpolation: 'polygon',
      lineWidth: 0,
      min: 0,
      tickInterval: 10,
    },
    tooltip: {
      shared: true,
      formatter: function () {
        return `<span><b>${((sum / 100) * this.y).toFixed(0)} (${this.y.toFixed(
          0
        )}%)</b><br/>`;
      },
      borderColor: '#12B2A7',
      backgroundColor: '#12B2A7',
      style: {
        color: '#fff',
      },
    },
    legend: false,
    exporting: {
      enabled: false,
    },
    colors: ['#12B2A7'],
    series: series,
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 400,
          },
          chartOptions: {
            pane: {
              size: '60%',
            },
          },
        },
      ],
    },
  };

  return (
    <div className='feature-griana Profession--chart'>
      <Chart options={option} />
    </div>
  );
}

ProfessionChart.defaultProps = {
  data: [
    {
      name: 'Civil servant',
      total: 1000,
    },
    {
      name: 'Health',
      total: 2222,
    },
    {
      name: 'Student',
      total: 5000,
    },
    {
      name: 'Entrepeneur',
      total: 7000,
    },
    {
      name: 'Agriculture',
      total: 2000,
    },
    {
      name: 'Unemployed',
      total: 3500,
    },
  ],
};

ProfessionChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      total: PropTypes.number,
    })
  ),
};
